import React from 'react';

import ModuleLoader from "src/modules/nextgen.module.loader";
import Seo from 'src/components/seo';
import HeadStyling from 'src/layouts/components/styling/head.styling';
import InAppLogin from 'src/components/inApp/in-app';

import { checkForSession } from 'src/services/session';

import {
  addViewportHeightResizeEventListener,
  removeViewportHeightResizeEventListener
} from 'src/utils/layout';

class Page extends React.Component {

  componentDidMount() {
    checkForSession();
    addViewportHeightResizeEventListener();
  }

  componentWillUnmount() {
    removeViewportHeightResizeEventListener();
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      return true;
    }
    return false;
}

  render() {
    const {pageContext, location} = this.props;
    const data = pageContext.page;

    data.selectedLanguage = pageContext.language;

    if(!data.background_color || (data.background_color && data.background_color.value && data.background_color.value === '')) {
      data.background_color = {
        value: 'transparent'
      };
    }
    return (
    <div id="pageWrapper" className="pageWrapper" style={{backgroundColor: data.background_color.value}}>
      <ModuleLoader
        destinationId={pageContext.destinationId}
        packageData={pageContext.packages}
        suppliers={pageContext.suppliers}
        oldSuppliers={pageContext.oldSuppliers}
        entries={pageContext.entries}
        rides={pageContext.rides}
        defaultLanguage={pageContext.defaultLanguage}
        language={data.selectedLanguage}
        modules={data.modules}
        location={location}
      />
      <InAppLogin />
    </div>
    )
  }
}

export const Head = ({ /*location, params*/ pageContext }) => {
  const data = pageContext.page;
  return (
    <>
      <HeadStyling key="hstyle" layout={pageContext.layout} />
      <Seo key="seo" data={data} pageContext={pageContext} />
    </>
  );
}


export default Page;
